import { useSelector } from "react-redux";

import { CircularLoader } from "app/components/React/CircularLoader/CircularLoader";
import {
    loaderStyles,
    ModalDetails,
    ModalHeading,
    modalStyled,
    StyledCancelButton,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactsTableActionsPanel/ExportContactsToCrm/shared/LoadingModal/styles";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { useTranslation } from "pro-features/components/WithTranslation";

import { selectAccountsCrmName, selectAccountsIntegration } from "../../store/selectors";

type AccountsLoadingModalProps = { isOpen: boolean; onClose(): void };

export const AccountsLoadingModal = ({ isOpen, onClose }: AccountsLoadingModalProps) => {
    const translate = useTranslation();
    const crm = useSelector(selectAccountsIntegration);
    const crmName = useSelector(selectAccountsCrmName);

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={modalStyled}
            data-automation="accounts-loading-modal"
        >
            <ModalHeading>{translate("si.advanced_search.accounts_export.matching_modal.title")}</ModalHeading>
            <ModalDetails>
                {translate(`si.advanced_search.accounts_export.matching_modal.description.${crm}`, {
                    crmName,
                })}
            </ModalDetails>

            <CircularLoader options={loaderStyles} />

            <StyledCancelButton
                type="flat"
                onClick={onClose}
                data-automation="accounts-loading-modal-cancel"
            >
                {translate("si.advanced_search.contacts_export.cancel_export")}
            </StyledCancelButton>
        </ProModal>
    );
};
